export const actionChangeStatusShowModalOrderDetails = (statusShow) => ({
    type:'CHANGE_STATUS_SHOW_MODAL_ORDER_DETAILS',
    statusShow
});
export const actionChangeSelectOrderModalOrderDetails = (order) => ({
    type: 'GET_DATA_INVOICE_IN_API_ORDER_DETAILS',order
});
export const actionChangeLoaderModalOrderDetails = (loader) => ({
    type: 'CHANGE_LOADER_MODAL_ORDER_DETAILS',loader
});
